import { formatActivityTimestamp } from "utilities/dateUtility";
import { DefaultColumnOptions } from "../../hooks/useDataGrid/options";

export const getColumns = () => [
  {
    headerName: "User Name",
    field: "userName",
    sortable: true,
    suppressColumnsToolPanel: true,
  },
  {
    headerName: "Message",
    field: "message",
    sortable: true,
  },
  {
    headerName: "TimeStamp",
    field: "createdAt",
    sortable: true,
    sort: "desc",
    cellRenderer: (params) => formatActivityTimestamp(params.data.createdAt),
  },
];
